import { apiWrapper } from "@/services/api";
import store from "@/store";

export const validPasses = async (pass_id) => {
  try {
    // APIで叩くパスIDの整理
    const apiParams = [];
    if (pass_id.match(/,/)) {
      pass_id.split(",").forEach(function (passEachID) {
        apiParams.push({ id: Number(passEachID) });
      });
    } else {
      apiParams.push({ id: Number(pass_id) });
    }

    const resp = await apiWrapper("POST", `valid_passes`, apiParams);

    store.commit("ticketing/setPass", resp.data[0]);
    return resp.data[0];
  } catch (err) {
    console.log("ERROR!!! validPasses");
    throw err;
  }
};
